import { alertVariants } from "@visiblethread/react-components";
import localhost from "apis/localhost";
import { MULTIPART_FORM_DATA_CONTENT_TYPE } from "constants/app";
import { showErrorModal } from "slices/app/actions/error";
import {
  addToJobQueue,
  removeFromJobQueue,
  showGlobalAlert,
} from "slices/app/appSlice";

const parseImportExportError = (dispatch, err) => {
  const { response, status } = err;
  if (status === 422) {
    const message = response?.data?.error;
    dispatch(
      showGlobalAlert({
        variant: alertVariants.danger,
        text: message,
      })
    );
    return;
  }
  dispatch(showErrorModal(err));
};

export const importListFromCsv = (formData, fileName) => async (dispatch) => {
  dispatch(addToJobQueue("importListFromCsv"));
  const listName = fileName.replace(/\.csv$/gi, "").trim();

  try {
    const url = `watchwords/import/csv?listName=${listName}`;
    const rsp = await localhost.post(url, formData, {
      headers: {
        "Content-Type": MULTIPART_FORM_DATA_CONTENT_TYPE,
      },
    });

    return rsp?.data;
  } catch (err) {
    parseImportExportError(dispatch, err);
    return null;
  } finally {
    dispatch(removeFromJobQueue("importListFromCsv"));
  }
};

export const exportListToCSV = (listId) => async (dispatch) => {
  dispatch(addToJobQueue("exportListToCSV"));
  try {
    const rsp = await localhost.get(`watchwords/${listId}/export/csv`);

    return new Blob([rsp?.data]);
  } catch (err) {
    parseImportExportError(dispatch, err);
    return null;
  } finally {
    dispatch(removeFromJobQueue("exportListToCSV"));
  }
};

export const setListAsDefault = (listId) => async (dispatch) => {
  dispatch(addToJobQueue("setListAsDefault"));
  try {
    const rsp = await localhost.post(`watchwords/${listId}/default`);

    return rsp?.data;
  } catch (err) {
    dispatch(showErrorModal(err));
    return null;
  } finally {
    dispatch(removeFromJobQueue("setListAsDefault"));
  }
};
